<template>
  <div
    v-if="fullyLoaded"
    class="pa-3 flex"
  >
    <div class="title mb-3">
      My indemnities
    </div>
    <section
      id="stats"
      class="mb-5"
    >
      <div
        v-if="myUWT[currentYear]"
        class="stat"
      >
        <div class="figure">
          {{ numberFormat(myUWT[currentYear]._cached_time_worked) }}
        </div>
        <div class="subtitle">
          hours worked in <strong>{{ currentYear }}</strong>
        </div>
      </div>
      <div
        v-if="myUWT[currentYear - 1]"
        class="stat"
      >
        <div class="figure">
          {{ numberFormat(myUWT[currentYear - 1]._cached_time_worked) }}
        </div>
        <div class="subtitle">
          hours worked in <strong>{{ currentYear - 1 }}</strong>
        </div>
      </div>
      <div
        v-if="myUWT[currentYear - 2]"
        class="stat"
      >
        <div class="figure">
          {{ numberFormat(myUWT[currentYear - 2]._cached_time_worked) }}
        </div>
        <div class="subtitle">
          hours worked in <strong>{{ currentYear - 2 }}</strong>
        </div>
      </div>
    </section>
    <div id="list">
      <indemnities-list
        v-if="fullyLoaded"
        ref="indemnitiesList"
        :trainer="true"
      />
    </div>
  </div>
</template>
<script>
  import GlobalMixin from "@/mixins/global"
  import IndemnitiesList from '@/components/payments/payments/Indemnities.vue'
  import Indemnities from '@/api/indemnities'
  import DateMixin from '@/mixins/date'

  const formater = new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: 2,  // Force au moins 2 décimales
    maximumFractionDigits: 2   // Limite à 2 décimales
  })

  export default {
    components: {IndemnitiesList},
    mixins: [GlobalMixin, DateMixin],
    data() {
      return {
        fullyLoaded: false,
        myUWT: {}, //uwt = user working time,
        currentYear: new Date().getFullYear()
      }
    },
    async mounted() {
      const {data} = await Indemnities.myCurrentWorkingTime()
      this.myUWT = data
      this.refreshIndemnities()
      this.fullyLoaded = true
    },
    methods: {
      refreshIndemnities(filtered = false) {
        this.$nextTick(() => {
          this.$refs.indemnitiesList && this.$refs.indemnitiesList.fetch(filtered ? 'filters' : 'local')
        })
      },
      numberFormat(number) {
        return formater.format( number )
      }
    }
  }
</script>
<style scoped lang="sass">
  #filters
    display: flex
    flex-direction: row
    align-items: center
    justify-content: start

    .v-input
      width: 250px
      flex: 0 0 auto !important

  #stats
    display: flex
    flex-direction: row
    justify-content: space-around
    flex-wrap: wrap

    .stat
      width: 25%
      min-width: 250px
      display: flex
      flex-direction: column
      background-color: white
      padding: 10px
      margin-top: 10px

      .figure
        font-weight: bold
        color: #f4b944
        font-size: 64px
        text-align: center

      .subtitle
        text-align: center
        color: #333333
        font-size: 1.1rem

      .sub-footer
        display: flex
        flex-direction: row
        justify-content: flex-end

        &.centered
          justify-content: center

        .alert
          margin-right: 5px
          width: 40px
          height: 40px
          font-size: 40px !important
          color: tomato

        .badge
          background-color: tomato
          color: white
          font-weight: bold
          display: flex
          font-size: 0.85rem
          justify-content: center
          align-items: center
          padding: 1px 6px
          border-radius: 25px
          align-self: flex-start
  .sub-filters-wrapper
    width: 100%
    display: flex
    flex-direction: row
    justify-content: space-between

  #global-actions
    display: flex
    flex-direction: center
    align-items: center

    a
      text-decoration: underline

  .sub-filters
    padding: 10px
    display: flex
    flex-direction: row
    justify-content: flex-start
    align-items: center
    flex-wrap: wrap

    > *
      width: 350px
      margin-right: 10px

      &.date
        width: 200px
      &.switch
        width: 270px
    a
      text-decoration: underline

  .w300p
    width: 300px
  .not-flex
    flex: none

  .inside-table
    border-collapse: collapse
    width: 100%

    tr:nth-child(event)
      background-color: #FAFAFA
    td
      border: 1px solid #F1F1F1
      padding: 10px 5px

  .alert
    padding: 2em
    border-radius: 9px
    border: 2px solid tomato
    color: tomato
    width: 100%
    font-size: 1.2rem
    display: flex
    flex-direction: row
    align-items: center

    i.v-icon
      font-size: 60px
      color: tomato
      margin-right: 20px

</style>
